export default function IconTemplate({ className }: { className?: string }) {
	return (
		<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" height="20" width="20" className={className}>
			<rect x="2" y="2" width="16" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<rect x="2" y="9.5" width="7" height="8.5" rx="1.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
			<rect x="11" y="9.5" width="7" height="8.5" rx="1.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
